import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	placeholderBracketHint: {
		id: 'full-page-editor.place.holder.bracket.hint',
		defaultMessage: 'Any element can be quickly inserted by typing /',
		description:
			'The placeholder text that appears in editor that already have content when user enter a new line and type {',
	},
	blogpostPermissionsNotice: {
		id: 'full-page-editor.permissions.blogpost-access',
		defaultMessage: 'Default access to this blog is now in effect.',
		description: 'Notice when selecting the blogpost blueprint to update preset access settings',
	},
	editorEmptyDocumentPlaceholder: {
		id: 'full-page-editor.content.placeholder.empty.doc',
		defaultMessage: 'Type / to insert elements',
		description: 'The placeholder shown in empty document to help discover slash command',
	},
});
